const CTASection = () => {
  return (
    <section className="py-24 px-6">
      <div className="max-w-5xl mx-auto bg-[#1F1F1F] text-[#F4F1EA] rounded-2xl p-12 lg:p-20 relative overflow-hidden text-center">
        <div className="absolute top-0 left-0 w-64 h-64 bg-[#b7eb6f] rounded-full blur-[80px] opacity-20"></div>
        <div className="absolute bottom-0 right-0 w-64 h-64 bg-[#b7eb6f] rounded-full blur-[80px] opacity-20"></div>
        <div className="relative z-10">
          <h2 className="font-serif-display text-4xl lg:text-6xl mb-6">Сэкономьте от 50000 руб на создании контента <br />и не ждите по несколько дней</h2>
          <p className="font-sans text-lg opacity-70 mb-12 max-w-2xl mx-auto">
            Пока вы ждёте — конкуренты тестируют. Trippy — это скорость, качество и экономия!
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a href="https://trippika.ru/seller-login" className="px-8 py-4 bg-[#b7eb6f] text-[#1F1F1F] rounded-lg font-typewriter text-sm uppercase tracking-widest shadow-lg hover:shadow-xl hover:bg-[#b7eb6f] transition-all inline-block">
              Попробовать бесплатно →
            </a>
            <a href="https://trippika.ru/seller-login" className="px-8 py-4 bg-transparent border border-white/20 text-white rounded-lg font-typewriter text-sm uppercase tracking-widest hover:bg-white/10 transition-all inline-block">
              Попробовать за 60 секунд
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
